/*
 * Copyright 2026 Sony Corporation
 */

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';

export interface PanelHeadProps {
  title: string;
  /** Collapses the panel to a rail. The three side panels share one slot, so they share one way out of it. */
  onHide: () => void;
}

export const PanelHead = ({ title, onHide }: PanelHeadProps) => (
  <Box className="flex items-center justify-between gap-1 px-4 pt-3 pb-1">
    <Typography variant="overline" color="text.secondary">
      {title}
    </Typography>
    <Tooltip title={`Hide ${title.toLowerCase()}`}>
      <IconButton size="small" aria-label={`Hide ${title.toLowerCase()}`} onClick={onHide}>
        <ChevronLeftIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  </Box>
);
